import { render } from "./SimpleIcon.vue?vue&type=template&id=3fcd692e&scoped=true"
import script from "./SimpleIcon.vue?vue&type=script&lang=js"
export * from "./SimpleIcon.vue?vue&type=script&lang=js"

import "./SimpleIcon.vue?vue&type=style&index=0&id=3fcd692e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcd692e"]])

export default __exports__